export default __webpack_public_path__ + "static/nucleus-ca596d1b160c0e71a924c945fadf02c1.jpg";